import request from '#/utils/request';
import { withFmsActor } from '#/api/fmsMgmt/fmsActorConfig';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * 請款單財務流程狀態操作（POST，皆帶 `X-User-Id`）。
 * 成功只回 `data.id／status／requestNo／statusChangedAt`；完整資料請重查 detail。
 */
async function postStatusAction(id, action, payload) {
  const { data: raw } = await request.post(
    `/fms/payment-requests/${id}/${action}`,
    payload == null ? undefined : keysToSnake(payload),
    withFmsActor(),
  );
  return parseVer4DetailResponse(raw);
}

/** `SUBMITTED → FINANCE_PROCESSING` */
export function startPaymentRequestProcessing(id) {
  return postStatusAction(id, 'processing');
}

/**
 * `FINANCE_PROCESSING → APPROVED／RETURNED`。
 * @param {{ approved: boolean, rejectReason?: string|null }} payload 退回時 rejectReason 必填
 */
export function reviewPaymentRequest(id, { approved, rejectReason = null }) {
  return postStatusAction(id, 'review', {
    approved: Boolean(approved),
    rejectReason: approved ? null : rejectReason,
  });
}

/** `APPROVED → PAID` */
export function payPaymentRequest(id) {
  return postStatusAction(id, 'payment');
}

/** `PAID → RECEIVED`（限該筆 payee） */
export function receivePaymentRequest(id) {
  return postStatusAction(id, 'receipt');
}

/** `RECEIVED → CLOSED` */
export function closePaymentRequest(id) {
  return postStatusAction(id, 'closure');
}

/** `SUBMITTED／FINANCE_PROCESSING／RETURNED → CANCELLED`；cancelReason 必填 */
export function cancelPaymentRequest(id, { cancelReason }) {
  return postStatusAction(id, 'cancellation', { cancelReason });
}
